import { API } from "aws-amplify";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { APIEndpoints } from "../../config";

const makeApiRequest = (formData: FormData) => {
  const postData = {
    body: formData,
  };

  return API.post(
    APIEndpoints.private,
    "/api/v1/registries/save-temporary-file",
    postData
  );
};

export const useCreateTempFile = () => {
  return useMutation<string, AxiosError, FormData>(
    (formData) => makeApiRequest(formData),
    {
      retry: 0,
    }
  );
};
